import {useEffect} from 'react';

import {useParams} from 'react-router-dom';

import {Grid} from '@mantine/core';

import {RecordForm} from '../forms/RecordForm';

import {
    FormPageLayout,
    PlatformLoader,
    TabbedComponent,
    TabComponentTab,
} from '@flexinet/ui-components';
import {Profile} from '../components/Profile';

import {EditPageNavigation} from '../navigation/EditPageNavigation';
import {useCustomerSubscription} from '../hooks/useCustomerSubscription.ts';

import {useEditPageTools} from '../hooks/useEditPageTools';

import {useCustomerSubscriptions} from "../hooks/useCustomerSubscriptions.ts";
import {IndexPage as SubscriptionItemsPage} from "../../subscription-items/pages/IndexPage.tsx";


export const EditPage = () => {

    const params = useParams();
    const resolvedSubscriptionId = params.subscriptionId || params.id;

    if (!resolvedSubscriptionId) {
        throw new Error('subscriptionId is required parameter');
    }

    const {fetchRecords} = useCustomerSubscriptions();

    const {
        record: subscription,
        fetchRecord,
        updateRecord,
    } = useCustomerSubscription(resolvedSubscriptionId);

    const {
        mode,
        tools,
    } = useEditPageTools();

    useEffect(() => {
        fetchRecords();
    }, []);

    useEffect(() => {
        fetchRecord();
    }, [resolvedSubscriptionId]);

    if (!subscription) {
        return <PlatformLoader message='Loading subscription...Please wait'/>;
    }

    const tabs = [
        {
            title: 'Line Items',
            component: <SubscriptionItemsPage subscriptionId={resolvedSubscriptionId}/>
        },
    ] as TabComponentTab[];


    return (
        <FormPageLayout
            title={subscription.id}
            pageNavigation={<EditPageNavigation component={subscription}/>}
            tools={tools}
        >


            {mode === 'view' ?

                <Grid>
                    <Grid.Col span={{
                        base: 12,
                        lg: 3
                    }}>
                        <Profile record={subscription}/>

                    </Grid.Col>
                    <Grid.Col span={{
                        base: 12,
                        lg: 9
                    }}>
                        <TabbedComponent tabs={tabs}/>
                    </Grid.Col>
                </Grid>


                :
                <RecordForm
                    record={subscription}
                    handleSubmit={updateRecord}
                />}


        </FormPageLayout>
    );
};
